// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4962":"55bca6eb1c8e41eb","6417":"2fe0301366cafdbb","8481":"9a2c3606258884cd"}[chunkId] + ".js";
};